import React from 'react';
import TextArea from '@narvar/nth-text-area';
import PropTypes from 'prop-types';
import s from './repairSidebar.module.css';

const RepairTextAreaComponent = ({
  textAreaValue,
  inputKey,
  component,
  onTextChange,
  maxCommentLength,
}) => {
  const [value, setValue] = React.useState(textAreaValue || '');
  const maxLengthClassName =
    value.length === maxCommentLength
      ? `${s.sidebar_comments_max_length} sidebar-comments-max-length`
      : '';
  return (
    <div>
      <p className={`${s.sidebar_comments_length} sidebar-comments-length ${maxLengthClassName}`}>
        {value.length}/{maxCommentLength}
      </p>
      <TextArea
        key={inputKey}
        id={inputKey}
        className={`sidebar-comments ${value ? 'filled-input' : ''}`}
        style={{ width: '100%' }}
        name={inputKey}
        label={component.placeholder}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onBlur={onTextChange}
        value={value}
        maxLength={maxCommentLength}
      />
    </div>
  );
};

RepairTextAreaComponent.defaultProps = {
  textAreaValue: '',
  inputKey: '',
  component: {},
  onTextChange: () => {},
  maxCommentLength: 500,
};

RepairTextAreaComponent.propTypes = {
  textAreaValue: PropTypes.string,
  inputKey: PropTypes.string,
  component: PropTypes.object,
  onTextChange: PropTypes.func,
  maxCommentLength: PropTypes.number,
};

export default RepairTextAreaComponent;
